import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO } from "../../data";
import { scrollToId } from "./useLenis";

const LINKS = [
    { label: "Menú", id: "menu" },
    { label: "Por qué", id: "porque" },
    { label: "Reseñas", id: "resenas" },
    { label: "Instagram", id: "instagram" },
    { label: "Ubicación", id: "ubicacion" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-300 ${
                scrolled
                    ? "bg-white/75 backdrop-blur-xl shadow-[0_8px_30px_rgba(233,30,140,0.12)] border-b border-white/50"
                    : "bg-transparent"
            }`}
        >
            <nav className="max-w-7xl mx-auto px-4 md:px-8 h-[64px] flex items-center justify-between">
                <button
                    data-testid="nav-logo"
                    onClick={() => go("hero")}
                    className="flex items-center shrink-0"
                    aria-label="Ir al inicio"
                >
                    <img
                        src={LOGO.nav}
                        alt="¡Qué Fresas! logo"
                        className="h-12 md:h-16 w-auto object-contain"
                    />
                </button>

                <div className="hidden md:flex items-center gap-1">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="font-label text-sm font-semibold uppercase tracking-wide text-[#6e4b58] hover:text-hotpink px-4 py-2 rounded-full hover:bg-hotpink/10 transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.96 }}
                        data-testid="nav-cta-menu"
                        onClick={() => go("menu")}
                        className="ml-2 bg-hotpink text-white font-display font-semibold px-5 py-2.5 rounded-full shadow-lg shadow-hotpink/30"
                    >
                        Ver Menú 🍓
                    </motion.button>
                </div>

                <button
                    data-testid="nav-hamburger"
                    onClick={() => setOpen((o) => !o)}
                    className="md:hidden w-11 h-11 grid place-items-center rounded-full bg-hotpink text-white shadow-lg shadow-hotpink/30"
                    aria-label="Abrir menú"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            <AnimatePresence>
                {open && (
                    <motion.div
                        data-testid="mobile-menu"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="md:hidden overflow-hidden bg-white/95 backdrop-blur-xl border-b border-pink-100"
                    >
                        <div className="px-4 py-4 flex flex-col gap-1">
                            {LINKS.map((l) => (
                                <button
                                    key={l.id}
                                    data-testid={`mobile-link-${l.id}`}
                                    onClick={() => go(l.id)}
                                    className="text-left font-display text-lg font-medium text-[#1a0a10] py-2.5 px-3 rounded-2xl hover:bg-hotpink/10"
                                >
                                    {l.label}
                                </button>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
};
